import { doc, onSnapshot } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { db, functions } from '../config/firebase';
import { getDeployTarget } from '../config/environment';
import { TOUR_PARTY_BILLING_COLLECTION } from '../constants/subscriptionPlans';

export { TOUR_PARTY_BILLING_COLLECTION };

export function subscribeTourPartyBilling(ownerId, tourId, onData, onError) {
  if (!ownerId || !tourId) {
    onData(null);
    return () => {};
  }
  const ref = doc(db, 'users', ownerId, TOUR_PARTY_BILLING_COLLECTION, tourId);
  return onSnapshot(
    ref,
    (snap) => onData(snap.exists() ? { id: snap.id, ...snap.data() } : null),
    onError,
  );
}

export async function startTourPartyCrewCheckout({ tourId, seatCount, successUrl, cancelUrl }) {
  const fn = httpsCallable(functions, 'createTourPartyCrewCheckout');
  const result = await fn({
    tourId,
    seatCount,
    deployTarget: getDeployTarget(),
    successUrl,
    cancelUrl,
  });
  return result?.data || {};
}

export async function syncTourPartyCrewCoverage({ tourId, ownerId }) {
  const fn = httpsCallable(functions, 'syncTourPartyCrewCoverage');
  const result = await fn({ tourId, ownerId });
  return result?.data || {};
}
